import { defineAsyncComponent } from 'vue';

const BUPlanWithdrawDepositDetail = defineAsyncComponent(() =>
  import('@/views/treasury/budgetPlanWithDraw/BUPlanWithdrawDepositDetail.vue')
);
const BUPlanWithdrawCashDetail = defineAsyncComponent(() =>
  import('@/views/treasury/budgetPlanWithDraw/BUPlanWithdrawCashDetail.vue')
);
const BUTransferDetail = defineAsyncComponent(() => import('@/views/treasury/bUTransfer/BUTransferDetail.vue'));
const BUTransferDepositDetail = defineAsyncComponent(() =>
  import('@/views/treasury/bUTransfer/BUTransferDepositDetail.vue')
);
const BUTreasuryFundTransferSalaryDetail = defineAsyncComponent(() =>
  import('@/views/treasury/bUTransfer/BUTreasuryFundTransferSalaryDetail.vue')
);
const BUTreasuryFundTransferInsurancePaymentDetail = defineAsyncComponent(() =>
  import('@/views/treasury/bUTransfer/BUTreasuryFundTransferInsurancePaymentDetail.vue')
);

const BUPlanWithdrawTransferDetail = defineAsyncComponent(() =>
  import('@/views/treasury/budgetPlanWithDraw/BUPlanWithdrawTransferDetail.vue')
);
const BUPlanWithdrawSalaryTransferDetail = defineAsyncComponent(() =>
  import('@/views/treasury/budgetPlanWithDraw/BUPlanWithdrawSalaryTransferDetail.vue')
);

const BUPlanReceiptDetail = defineAsyncComponent(() =>
  import('@/views/treasury/budgetPlanReceipt/BUPlanReceiptDetail.vue')
);

const BUPlanCancelDetail = defineAsyncComponent(() =>
  import('@/views/treasury/budgetPlanCancel/BUPlanCancelDetail.vue')
);

const BUVoucherListPlannedDetail = defineAsyncComponent(() =>
  import('@/views/treasury/bUVoucherList/BUVoucherListPlannedDetail.vue')
);
const BUPlanAdjustmentDetail = defineAsyncComponent(() =>
  import('@/views/treasury/budgetPlanAdjustment/BUPlanAdjustmentDetail.vue')
);

const ApproveVoucherBUPlanAdjustmentTab = defineAsyncComponent(() =>
  import('@/views/treasury/budgetPlanAdjustment/ApproveVoucherBUPlanAdjustmentTab.vue')
);

const BUExpenseWithdrawAdjustmentDetail = defineAsyncComponent(() =>
  import('@/views/treasury/buPlanWDAdjustment/BUExpenseWithdrawAdjustmentDetail.vue')
);

const BURealExpenseAdjustmentDetail = defineAsyncComponent(() =>
  import('@/views/treasury/buPlanWDAdjustment/BURealExpenseAdjustmentDetail.vue')
);

const BUBudgetReserveDetail = defineAsyncComponent(() =>
  import('@/views/treasury/budgetReserve/BUBudgetReserveDetail.vue')
);

const ApproveVoucherBUBudgetReserveTab = defineAsyncComponent(() =>
  import('@/views/treasury/budgetReserve/ApproveVoucherBUBudgetReserveTab.vue')
);
const BUVoucherListNotPlannedDetail = defineAsyncComponent(() =>
  import('@/views/treasury/bUVoucherList/BUVoucherListNotPlannedDetail.vue')
);

const BUVoucherListReceipExpenseDetail = defineAsyncComponent(() =>
  import('@/views/treasury/bUVoucherList/BUVoucherListReceipExpenseDetail.vue')
);

const BUVoucherListOtherDetail = defineAsyncComponent(() =>
  import('@/views/treasury/bUVoucherList/BUVoucherListOtherDetail.vue')
);

const BUVoucherListRealExpenseDetail = defineAsyncComponent(() =>
  import('@/views/treasury/bUVoucherList/BUVoucherListRealExpenseDetail.vue')
);

const BUCommitmentRequestDetail = defineAsyncComponent(() =>
  import('@/views/treasury/bUCommitment/bUCommitmentRequest/BUCommitmentRequestDetail.vue')
);

const BUCommitmentAdjustmentDetail = defineAsyncComponent(() =>
  import('@/views/treasury/bUCommitment/bUCommitmentAdjustment/BUCommitmentAdjustmentDetail.vue')
);

const ApproveVoucherBUCommitmentAdjustmentTab = defineAsyncComponent(() =>
  import('@/views/treasury/bUCommitment/bUCommitmentAdjustment/ApproveVoucherBUCommitmentAdjustmentTab.vue')
);

const ApproveVoucherBUCommitmentRequestTab = defineAsyncComponent(() =>
  import('@/views/treasury/bUCommitment/bUCommitmentRequest/ApproveVoucherBUCommitmentRequestTab.vue')
);

const BUOpeningCommitmentDetail = defineAsyncComponent(() =>
  import('@/views/treasury/bUCommitment/bUOpeningCommitment/BUOpeningCommitmentDetail.vue')
);

const BUPlanImportDetail = defineAsyncComponent(() => import('@/views/treasury/bUPlanImport/BUPlanImportDetail.vue'));

const BUPlanImportPopup = defineAsyncComponent(() => import('@/views/treasury/bUPlanImport/BUPlanImportPopup.vue'));

const BUPlanImportDetailQuickSearchPopup = defineAsyncComponent(() =>
  import('@/views/treasury/bUPlanImport/BUPlanImportDetailQuickSearchPopup.vue')
);

const BUPlanWithdrawGenPopup = defineAsyncComponent(() => import('@/views/treasury/BUPlanWithdrawGenPopup.vue'));
const BUOpeningCommitmentPopup = defineAsyncComponent(() =>
  import('@/views/treasury/bUTransfer/BUOpeningCommitmentPopup.vue')
);

const ViewAccount = defineAsyncComponent(() => import('@/views/treasury/bUTransfer/ViewAccount.vue'));

const BUChooseVoucherListOtherDetailPopup = defineAsyncComponent(() =>
  import('@/views/treasury/bUVoucherList/BUChooseVoucherListOtherDetailPopup.vue')
);
const ApproveVoucherBUPlanReceipt = defineAsyncComponent(() =>
  import('@/views/treasury/budgetPlanReceipt/ApproveVoucherBUPlanReceipt.vue')
);

const PostedErrorPopup = defineAsyncComponent(() => import('@/views/postedError/PostedErrorPopup.vue'));

const ApproveVoucherBUPlanCancelTab = defineAsyncComponent(() =>
  import('@/views/treasury/budgetPlanCancel/ApproveVoucherBUPlanCancelTab.vue')
);

const ApproveVoucherBUPlanWDAdjustmentTab = defineAsyncComponent(() =>
  import('@/views/treasury/buPlanWDAdjustment/ApproveVoucherBUPlanWDAdjustmentTab.vue')
);

const BUPlanWWDAjustmentGetData = defineAsyncComponent(() =>
  import('@/views/treasury/buPlanWDAdjustment/BUPlanWDAdjustmentGetDataPopup.vue')
);

const ProduceVoucherPopup = defineAsyncComponent(() =>
  import('@/views/treasury/budgetPlanWithDraw/ProduceVoucherPopup.vue')
);
const ApproveVoucherBUPlanWithdrawTab = defineAsyncComponent(() =>
  import('@/views/treasury/budgetPlanWithDraw/ApproveVoucherBUPlanWithdrawTab.vue')
);

const ApproveVoucherBUTransferTab = defineAsyncComponent(() =>
  import('@/views/treasury/bUTransfer/ApproveVoucherBUTransferTab.vue')
);

const ErrorVoucherNotification = defineAsyncComponent(() => import('@/views/postedError/ErrorVoucherNotification.vue'));

const BUPlanImportFromBumasPopup = defineAsyncComponent(() =>
  import('@/views/treasury/bUPlanImport/BUPlanImportFromBumasPopup.vue')
);

const BUPlanReceiptFromBumasPopup = defineAsyncComponent(() => 
  import('@/views/treasury/budgetPlanReceipt/BUPlanReceiptFromBumasPopup.vue')
);

const B58KTNNDetail = defineAsyncComponent(() => import('@/views/treasury/bUTreasuryReconciliation/B58KTNNDetail.vue'));

const ValidateSyncDictionaryPopup = defineAsyncComponent(() =>
  import('@/views/treasury/bUPlanImport/ValidateSyncDictionaryPopup.vue')
);
const BUPlanWDAdjustmentGetDataExpensePopup = defineAsyncComponent(() =>
  import('@/views/treasury/buPlanWDAdjustment/BUPlanWDAdjustmentGetDataExpensePopup.vue')
);

const BUNotPayVoucherList = defineAsyncComponent(() =>
  import('@/views/treasury/bUVoucherList/BUNotPayVoucherList.vue')
);

export function registerTreasury(app) {
  app.component('BUPlanWithdrawDepositDetail', BUPlanWithdrawDepositDetail);
  app.component('BUPlanWithdrawCashDetail', BUPlanWithdrawCashDetail);
  app.component('BUPlanWithdrawTransferDetail', BUPlanWithdrawTransferDetail);
  app.component('BUPlanWithdrawSalaryTransferDetail', BUPlanWithdrawSalaryTransferDetail);
  app.component('BUTransferDepositDetail', BUTransferDepositDetail);
  app.component('BUTreasuryFundTransferSalaryDetail', BUTreasuryFundTransferSalaryDetail);
  app.component('BUTreasuryFundTransferInsurancePaymentDetail', BUTreasuryFundTransferInsurancePaymentDetail);
  app.component('BUTransferDetail', BUTransferDetail);
  app.component('BUPlanReceiptDetail', BUPlanReceiptDetail);
  app.component('BUPlanCancelDetail', BUPlanCancelDetail);
  app.component('BUVoucherListPlannedDetail', BUVoucherListPlannedDetail);
  app.component('BUPlanAdjustmentDetail', BUPlanAdjustmentDetail);
  app.component('ApproveVoucherBUPlanAdjustmentTab', ApproveVoucherBUPlanAdjustmentTab);
  app.component('BUExpenseWithdrawAdjustmentDetail', BUExpenseWithdrawAdjustmentDetail);
  app.component('BURealExpenseAdjustmentDetail', BURealExpenseAdjustmentDetail);
  app.component('BUBudgetReserveDetail', BUBudgetReserveDetail);
  app.component('ApproveVoucherBUBudgetReserveTab', ApproveVoucherBUBudgetReserveTab);
  app.component('BUVoucherListNotPlannedDetail', BUVoucherListNotPlannedDetail);
  app.component('BUVoucherListReceipExpenseDetail', BUVoucherListReceipExpenseDetail);
  app.component('BUVoucherListOtherDetail', BUVoucherListOtherDetail);
  app.component('BUVoucherListRealExpenseDetail', BUVoucherListRealExpenseDetail);
  app.component('BUCommitmentRequestDetail', BUCommitmentRequestDetail);
  app.component('BUCommitmentAdjustmentDetail', BUCommitmentAdjustmentDetail);
  app.component('BUOpeningCommitmentDetail', BUOpeningCommitmentDetail);
  app.component('BUPlanImportDetail', BUPlanImportDetail);
  app.component('BUPlanImportDetailQuickSearchPopup', BUPlanImportDetailQuickSearchPopup);
  app.component('BUPlanImportPopup', BUPlanImportPopup);
  app.component('BUPlanWithdrawGenPopup', BUPlanWithdrawGenPopup);
  app.component('ViewAccount', ViewAccount);
  app.component('BUOpeningCommitmentPopup', BUOpeningCommitmentPopup);
  app.component('PostedErrorPopup', PostedErrorPopup);
  app.component('BUChooseVoucherListOtherDetailPopup', BUChooseVoucherListOtherDetailPopup);
  app.component('ApproveVoucherBUPlanReceipt', ApproveVoucherBUPlanReceipt);
  app.component('ApproveVoucherBUPlanWDAdjustmentTab', ApproveVoucherBUPlanWDAdjustmentTab);
  app.component('BUPlanWWDAjustmentGetData', BUPlanWWDAjustmentGetData);
  app.component('ProduceVoucherPopup', ProduceVoucherPopup);

  app.component('ApproveVoucherBUCommitmentRequestTab', ApproveVoucherBUCommitmentRequestTab);
  app.component('ApproveVoucherBUCommitmentAdjustmentTab', ApproveVoucherBUCommitmentAdjustmentTab);
  app.component('ApproveVoucherBUPlanCancelTab', ApproveVoucherBUPlanCancelTab);
  app.component('ApproveVoucherBUTransferTab', ApproveVoucherBUTransferTab);
  app.component('ApproveVoucherBUPlanWithdrawTab', ApproveVoucherBUPlanWithdrawTab);
  app.component('ErrorVoucherNotification', ErrorVoucherNotification);
  app.component('B58KTNNDetail', B58KTNNDetail);
  app.component('BUPlanImportFromBumasPopup', BUPlanImportFromBumasPopup);
  app.component('BUPlanReceiptFromBumasPopup', BUPlanReceiptFromBumasPopup);
  app.component('ValidateSyncDictionaryPopup', ValidateSyncDictionaryPopup);
  app.component('BUPlanWDAdjustmentGetDataExpensePopup', BUPlanWDAdjustmentGetDataExpensePopup);
  app.component('BUNotPayVoucherList', BUNotPayVoucherList);
}
